import React from "react";
import { AlertCircle, FileText } from "lucide-react";
import { Layout } from "@/components/Layout";
import { LEGAL } from "@/content";

function Pending({ title }) {
  return (
    <div data-testid={`legal-pending-${title.toLowerCase().replace(/[^a-z]/g, "-")}`} className="rounded-2xl border border-dashed border-white/15 bg-ink-800/50 p-7">
      <div className="flex items-center gap-3">
        <AlertCircle size={18} className="text-cyan" />
        <h3 className="font-display text-xl font-bold text-white">{title}</h3>
        <span className="label text-cyan ml-auto">Draft / Pending</span>
      </div>
      <p className="text-mist mt-3 text-sm leading-relaxed">
        This document is being drafted separately and will be published here once finalised. Placeholder text is not legal advice.
      </p>
    </div>
  );
}

export default function Legal() {
  return (
    <Layout page="legal">
      <section className="relative pt-40 pb-14 overflow-hidden">
        <div className="absolute inset-0 mesh-top" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
          <span className="label">Legal & Copyright</span>
          <h1 className="font-display font-black text-white tracking-tighter mt-4 leading-[0.95]" style={{ fontSize: "clamp(2.6rem, 8vw, 6rem)" }}>Legal</h1>
        </div>
      </section>

      <section className="relative py-8 pb-32">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 space-y-6">
          <div className="rounded-2xl border border-white/10 glass p-7">
            <div className="flex items-center gap-3 mb-4">
              <FileText size={18} className="text-cyan" />
              <h2 className="font-display text-xl font-bold text-white">Copyright Notice</h2>
            </div>
            <p className="text-ice/75 leading-relaxed text-sm">{LEGAL.copyright}</p>
          </div>

          <Pending title="Privacy Policy" />
          <Pending title="Terms & Conditions" />
          <Pending title="Cookie Policy" />

          <p className="text-mist text-xs pt-4">
            This build supports UK GDPR requirements including secure form handling, and admin export/deletion of client records. Final legal wording will replace these placeholders.
          </p>
        </div>
      </section>
    </Layout>
  );
}
